import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const useGetCheckIfPhoneIsVerified = () => {
  const apiClient = useApiClient(ClientApiClient)

  const { data, isPending, isError } = useQuery({
    queryKey: queryKeys.deposit.phoneVerified(),
    queryFn: () => apiClient.getIsPhoneVerified(),
  })

  return {
    isVerified: isError ? false : data?.isVerified,
    isPhoneVerificationLoading: isError ? false : isPending,
    verificationEnabled: isError ? true : data?.verificationEnabled,
  }
}
